import * as React from "react";
import {Icon} from "./Icon";

export class ReaderIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M24,18l9.95-5A10.12,10.12,0,0,0,34,12a10,10,0,0,0-20,0,10.12,10.12,0,0,0,.05,1Z"/>
        <path d="M41,30a5,5,0,1,1,1.81-9.65L44,12,24,22,4,12l1.19,8.35A5,5,0,1,1,7,30c-0.15,0-.29,0-0.43,0L8,40l16,6,16-6,1.43-10C41.29,30,41.15,30,41,30Z"/>
      </svg>
    </Icon>;
  }
}
